import React, {createContext, ReactNode, useEffect, useState} from 'react';
import moment from "moment";
import {WeekPicker} from '../template/WeekPicker'
import {YearPicker} from '../template/YearPicker'
import {IsLiveInputSwitch} from "../template/IsLiveInputSwitch";
import {OnlineSessionState, OnlineSessionSyncDto} from "../services/api";
import {doesWeekCrossYear} from "../common";

export interface WeekPickerState {
    weekNumber: number;
    year: number;
    firstDateOfTheWeek: Date;
}

export interface YearPickerState {
    year: number;
}

export interface HeaderContextType {
    weekPickerState: WeekPickerState;
    updateWeekPicker: (date: Date) => void;
    yearPickerState: YearPickerState;
    updateYearPicker: (date: Date) => void;
    isLiveState: IsLiveState;
    updateIsLive: (date: Partial<IsLiveState>) => void;
    countdownState: OnlineSessionSyncDto | undefined,
    updateCountdown: (countdownState: OnlineSessionSyncDto) => void;
    updateComponent: (newComponent: "weekpicker" | "yearpicker" | 'islive' | React.ReactNode) => void;
    addComponent: (Component : ReactNode) => void;
    clearComponent: () => void;
    component: ReactNode | undefined;
}

export interface WeekPickerState {
    weekNumber: number;
    year: number;
    firstDateOfTheWeek: Date;
}

export interface IsLiveState {
    isLive: boolean;
    isButtonClicked: boolean;
    isOnline: boolean;
}

export const HeaderContext = createContext<HeaderContextType>({} as HeaderContextType);

export const HeaderContextProvider = (props: any) => {
    const weekPickerInitialState : WeekPickerState = {
        weekNumber: moment().isoWeek(),
        year: moment().year(),
        firstDateOfTheWeek: moment().isoWeekday(1).toDate()
    }

    const yearPickerInitialState: YearPickerState = {
        year: moment().year(),
    }

    const isLiveInitialState : IsLiveState = {
        isButtonClicked: false,
        isLive: false,
        isOnline: false
    };


    const [isLiveState, setIsLiveState] = useState(isLiveInitialState);
    const [yearPickerState, setYearPickerState] = useState(yearPickerInitialState);
    const [weekPickerState, setWeekPickerState] = useState(weekPickerInitialState);
    const [countdownState, setCountdownState] = useState<OnlineSessionSyncDto>();
    const [component, setComponent] = useState<React.ReactNode | undefined>();


    const updateWeekPicker = (date: Date) => {
        const firstDateOfTheWeek = moment(date).isoWeekday(1).toDate();
        const weekNumber = moment(date).isoWeek();
        let year = moment(date).year();

        if(doesWeekCrossYear(date)) year += 1;


        setWeekPickerState({firstDateOfTheWeek, weekNumber, year});
    }

    useEffect(() => {
        updateWeekPicker(new Date());
    }, []);

    const updateCountdown = (countdownState: OnlineSessionSyncDto) => {
        setCountdownState(countdownState);
    }

    const updateYearPicker = (date: Date) => {
        const year = moment(date).year();

        setYearPickerState({year});
    }

    const updateIsLive = (data: Partial<IsLiveState>) => {
        setIsLiveState(prevState => {return {...prevState, ...data}});
    }

    const updateComponent = (newComponent: "weekpicker" | "yearpicker" | "islive" | React.ReactNode) => {
        if(newComponent === 'weekpicker')
            setComponent(<WeekPicker />);
        else if(newComponent === 'yearpicker')
            setComponent(<YearPicker />);
        else if(newComponent === 'islive'){
            setComponent(<IsLiveInputSwitch />)
        }
        else
            setComponent(newComponent);
    }

    const addComponent = (component: React.ReactNode) => {
        setComponent(prevState => {return [prevState, component]});
    }


    const clearComponent = () => {
        setComponent(undefined);
        setYearPickerState(yearPickerInitialState);
        // setWeekPickerState(weekPickerInitialState);
    }

    return <>
        <HeaderContext.Provider value={{weekPickerState, updateWeekPicker, yearPickerState, updateYearPicker, isLiveState, updateIsLive, countdownState, updateCountdown, updateComponent, addComponent, clearComponent, component}}>
            {props.children}
        </HeaderContext.Provider>
    </>
};
